module.exports = __webpack_public_path__ + "static/media/h3.30fb8b91.svg";